export default __webpack_public_path__ + "static/media/dozule21.8fc638c3.jpg";